import { MAIN_DOMAIN, PROTOCOL } from 'config/env'
import { InitialValues } from 'pages/Login/LuckyBird/types'

export const redirectLuckyBird = (subdomainCMS: string, code: string) =>
  window.location.assign(`${PROTOCOL}://${subdomainCMS}.${MAIN_DOMAIN}/auth/luckybird?luckyBirdCode=${code}`)

export const field = (name: keyof InitialValues) => name
